module.exports = __webpack_public_path__ + "static/RingSavvy-ICB-Hero_mobile-c786292d5f7d8e417e43fddaff444249.jpg";